import styled, { css } from 'styled-components'

import { DefinitionGrid } from '~/components/DefinitionGrid'
import { device } from '~/styles/device'

/**
 * A grade do desenho, mais o que é específico deste painel: nome de dia da
 * semana capitalizado e o par logo-e-nome de anunciante e publisher.
 */
export const Grid = styled(DefinitionGrid)`
  .dateLabel::first-letter {
    text-transform: capitalize;
  }
`

/**
 * `div`, e não `span`, nos dois: o que eles embrulham renderiza `div` — o
 * `LogoStore` e o `Tooltip` —, e conteúdo de fluxo dentro de elemento de frase é
 * markup inválido, que serializador e leitor de DOM podem reinterpretar. Ambos
 * vivem dentro de `dt`/`dd`, que aceitam fluxo. O `inline-flex` explícito é o
 * que mantém a linha se comportando como antes.
 */
export const Party = styled.div`
  display: inline-flex;
  align-items: center;
  gap: var(--sl-space-2);
`

export const Term = styled.div`
  display: inline-flex;
  align-items: center;
`

export const RowWrapper = styled.div`
  ${({ theme }) => css`
    &.hasBorder {
      & + .hasBorder {
        border-top: 1px solid ${theme.colors.tertiary};
        padding-top: 1rem;
      }
    }

    &:not(:first-child) {
      margin-top: 1rem;
    }
  `}
`

/** Sobra do modo de edição: o de leitura virou grade. */
export const Wrapper = styled.div`
  ${({ theme }) => css`
    &:not(:first-child) {
      margin-top: 0.5rem;
    }

    > strong {
      color: ${theme.colors.primary};
      margin-bottom: 0.25rem;
    }
  `}
`

export const GroupWrapper = styled.div`
  ${({ theme }) => css`
    @media ${device.laptop} {
      display: flex;
    }

    > ${Wrapper} {
      &:not(:first-child) {
        border: solid ${theme.colors.tertiary};
        border-width: 1px 0 0 0;
        margin: 0.125rem 0 0 0;
        padding: 0.125rem 0 0 0;

        @media ${device.laptop} {
          border-width: 0 0 0 1px;
          margin: 0 0 0 1.5rem;
          padding: 0 0 0 1.5rem;
        }
      }
    }
  `}
`

export const EditSectionWrapper = styled.div`
  margin-top: 1rem;
`
